export default __webpack_public_path__ + "static/media/menu.c57a29ed.svg";